

import {
  ArrowLeft,
  Smartphone,
  User,
  FolderOpen,
  Pencil,
  Upload,
  FileText,
  Eye,
  Trash2
} from "lucide-react";

import React, {
  useEffect,
  useState
} from "react";

import {
  useNavigate,
  useParams
} from "react-router-dom";

import api from "../api";

import {
  toast
} from "react-toastify";

import "../Styles/SimCardDetails.css";

const SimCardDetails = () => {


const { id } =
useParams();

const navigate =
useNavigate();

const [loading,
setLoading] =
useState(true);

const [sim,
setSim] =
useState(null);

const [kyc,
setKyc] =
useState(null);

const [documents,
setDocuments] =
useState([]);

const [editingKYC,
setEditingKYC] =
useState(false);

const [saving,
setSaving] =
useState(false);

const [form,
setForm] =
useState({

first_name:"",

last_name:"",

contact_number:"",

email:"",

address:"",

id_type:"NATIONAL_ID",

id_number:"",

date_of_issue:"",

date_of_expiry:""

});


const [selectedFile,
setSelectedFile] =
useState(null);

const [documentType,
setDocumentType] =
useState("NATIONAL_ID");

const [uploading,
setUploading] =
useState(false);




useEffect(()=>{

loadPage();

},[id]);

async function loadPage(){

try{

setLoading(true);

const simResult =
await api.getSimCard(id);

setSim(simResult);

const kycResult =
await api.getSimKYC(id);

if(kycResult){

setKyc(kycResult);

const docs =
await api.getSimDocuments(
kycResult.id
);

setDocuments(docs);

}

else{

setKyc(null);

setDocuments([]);

}

}

catch(err){

console.error(err);

toast.error(
"Failed to load SIM."
);

}

finally{

setLoading(false);

}

}

useEffect(()=>{

if(kyc){

setForm({

first_name:
kyc.first_name || "",

last_name:
kyc.last_name || "",

contact_number:
kyc.contact_number || "",

email:
kyc.email || "",

address:
kyc.address || "",

id_type:
kyc.id_type || "NATIONAL_ID",

id_number:
kyc.id_number || "",

date_of_issue:
kyc.date_of_issue?.split("T")[0] || "",

date_of_expiry:
kyc.date_of_expiry?.split("T")[0] || ""

});

}

},[kyc]);


async function saveKYC(){

try{

setSaving(true);

if(kyc){

await api.updateSimKYC(

id,

form

);

toast.success(
"KYC Updated."
);

}

else{

await api.createSimKYC(

id,

form

);

toast.success(
"KYC Saved."
);

}

await loadPage();

setEditingKYC(false);

}

catch(err){

console.error(err);

toast.error(
"Failed to save KYC."
);

}

finally{

setSaving(false);

}

}

async function uploadDocument(){

if(!kyc){

toast.error(
"Save KYC first."
);

return;

}

if(!selectedFile){

toast.error(
"Select a file."
);

return;

}

try{

setUploading(true);

await api.uploadSimDocument(

kyc.id,

selectedFile,

documentType

);

toast.success(
"Document uploaded."
);

await loadPage();

setSelectedFile(null);

}

catch(err){

console.error(err);

toast.error(
"Upload failed."
);

}

finally{

setUploading(false);

}

}

async function viewDocument(doc){

const result =
await api.getSimDocumentUrl(
doc.id
);

if(result?.url){

window.open(
result.url,
"_blank"
);

}

}

async function deleteDocument(doc){

if(

!window.confirm(

"Delete this document?"

)

){

return;

}

await api.deleteSimDocument(
doc.id
);

toast.success(
"Document deleted."
);

loadPage();

}

async function deleteSIM(){

if(

!window.confirm(

"This will permanently delete this SIM, its KYC and all uploaded documents. Continue?"

)

){

return;

}

try{

await api.deleteSim(id);

toast.success(
"SIM deleted."
);

navigate("/sim-cards");

}

catch(err){

console.error(err);

toast.error(
"Delete failed."
);

}

}



if(loading){

return(

<div className="accounts-loading-screen">

Loading...

</div>

);

}






  return (

    <div className="sim-details-page">

      {/* HEADER */}

      <div className="sim-details-header">

        <button
          className="back-btn"
          onClick={() =>
            navigate("/sim-cards")
          }
        >

          <ArrowLeft size={18} />

          Back

        </button>

        <div className="header-actions">
<button
className="glass-btn danger"
onClick={deleteSIM}
>

<Trash2 size={18}/>

Delete SIM

</button>
          <button className="glass-btn secondary">

            <Pencil size={18} />

            Edit SIM

          </button>

<button
  className={
    kyc
      ? "glass-btn success"
      : "glass-btn primary"
  }
  onClick={() => {

    if (!kyc) {

      setEditingKYC(true);

    }

  }}
>

  <User size={18} />

  {

    kyc

      ? "KYC Completed"

      : "Complete Sale"

  }

</button>

        </div>

      </div>

      {/* HERO */}

      <div className="sim-hero-card">

        <div>

          <span className="hero-pill">

            <Smartphone size={15} />

            SIM Details

          </span>

          <h1>

            {sim?.gsm_number}

          </h1>

          <p>

            {sim?.network}

          </p>

        </div>

        <div className="status-large available">

          {sim?.status}

        </div>

      </div>

      {/* BODY */}

      <div className="sim-details-grid">

        {/* SIM INFO */}

        <div className="details-card">

          <h2>

            SIM Information

          </h2>

          <div className="info-grid">

            <div>

              <label>
                GSM Number
              </label>

              <span>
                {sim?.gsm_number}

              </span>

            </div>

            <div>

              <label>
                Network
              </label>

              <span>
                {sim?.network}

              </span>

            </div>

            <div>

              <label>
                Serial Number
              </label>

              <span>
                {sim?.serial_number}
              </span>

            </div>

            <div>

              <label>
                Status
              </label>

              <span>
                {sim?.status}
                
              </span>

            </div>

          </div>

        </div>

        {/* KYC */}

       <div className="details-card">

  <div className="card-header">

    <h2>

      Customer KYC

    </h2>

<button

className="glass-btn primary"

onClick={()=>{

setEditingKYC(true);

}}

>

<User size={16}/>

{

kyc

?

"Edit KYC"

:

"Complete Sale"

}

</button>

  </div>

{

editingKYC ? (

<form className="kyc-form">

<div className="kyc-grid">

<div className="input-group">

<label>

First Name

</label>

<input

value={form.first_name}

onChange={(e)=>

setForm({

...form,

first_name:e.target.value

})

}

/>

</div>

<div className="input-group">

<label>

Last Name

</label>

<input

value={form.last_name}

onChange={(e)=>

setForm({

...form,

last_name:e.target.value

})

}

/>

</div>

<div className="input-group">

<label>

Contact Number

</label>

<input

value={form.contact_number}

onChange={(e)=>

setForm({

...form,

contact_number:e.target.value

})

}

/>

</div>

<div className="input-group">

<label>

Email

</label>

<input

type="email"

value={form.email}

onChange={(e)=>

setForm({

...form,

email:e.target.value

})

}

/>

</div>

<div className="input-group full-width">

<label>

Address

</label>

<textarea

rows={3}

value={form.address}

onChange={(e)=>

setForm({

...form,

address:e.target.value

})

}

/>

</div>

<div className="input-group">

<label>

ID Type

</label>

<select

value={form.id_type}

onChange={(e)=>

setForm({

...form,

id_type:e.target.value

})

}

>

<option value="NATIONAL_ID">

National ID

</option>

<option value="PASSPORT">

Passport

</option>

<option value="DRIVERS_LICENCE">

Driver's Licence

</option>

</select>

</div>

<div className="input-group">

<label>

ID Number

</label>

<input

value={form.id_number}

onChange={(e)=>

setForm({

...form,

id_number:e.target.value

})

}

/>

</div>

<div className="input-group">

<label>

Date Issued

</label>

<input

type="date"

value={form.date_of_issue}

onChange={(e)=>

setForm({

...form,

date_of_issue:e.target.value

})

}

/>

</div>

<div className="input-group">

<label>

Date Expires

</label>

<input

type="date"

value={form.date_of_expiry}

onChange={(e)=>

setForm({

...form,

date_of_expiry:e.target.value

})

}

/>

</div>

</div>

<div className="kyc-actions">

<button

type="button"

className="glass-btn secondary"

onClick={()=>{

setEditingKYC(false);

}}

>

Cancel

</button>

<button

type="button"

className="glass-btn primary"

onClick={saveKYC}

disabled={saving}

>

{

saving

?

"Saving..."

:

"Save KYC"

}

</button>

</div>

</form>

) : !kyc ? (

<div className="empty-card">

<User size={40}/>

<h3>

No Customer Assigned

</h3>

<p>

This SIM has not yet been sold.

</p>

</div>

) : (

<div className="info-grid">

<div>

<label>

First Name

</label>

<span>

{kyc.first_name}

</span>

</div>

<div>

<label>

Last Name

</label>

<span>

{kyc.last_name}

</span>

</div>

<div>

<label>

Contact

</label>

<span>

{kyc.contact_number}

</span>

</div>

<div>

<label>

Email

</label>

<span>

{kyc.email}

</span>

</div>

<div>

<label>

Address

</label>

<span>

{kyc.address}

</span>

</div>

<div>

<label>

ID Type

</label>

<span>

{kyc.id_type}

</span>

</div>

<div>

<label>

ID Number

</label>

<span>

{kyc.id_number}

</span>

</div>

<div>

<label>

Issue Date

</label>

<span>

{
kyc.date_of_issue
  ? new Date(
      kyc.date_of_issue
    ).toLocaleDateString(
      "en-GB",
      {
        day: "2-digit",
        month: "short",
        year: "numeric"
      }
    )
  : "-"
}

</span>

</div>

<div>

<label>

Expiry Date

</label>

<span>

{
kyc.date_of_expiry
  ? new Date(
      kyc.date_of_expiry
    ).toLocaleDateString(
      "en-GB",
      {
        day: "2-digit",
        month: "short",
        year: "numeric"
      }
    )
  : "-"
}

</span>

</div>

</div>

)

}

</div>
        {/* DOCUMENTS */}
<div className="details-card full-width">

  <div className="card-header">

    <h2>

      Documents

    </h2>

<div className="document-upload">

<input

type="file"

onChange={(e)=>

setSelectedFile(

e.target.files[0]

)

}

/>

<select

value={documentType}

onChange={(e)=>

setDocumentType(

e.target.value

)

}

>

<option value="NATIONAL_ID">

National ID

</option>

<option value="PASSPORT">

Passport

</option>

<option value="DRIVERS_LICENCE">

Driver's Licence

</option>

<option value="OTHER">

Other

</option>

</select>

<button

className="glass-btn primary"

onClick={uploadDocument}

>

<Upload size={16}/>

{

uploading

?

"Uploading..."

:

"Upload"

}

</button>

</div>

  </div>

  <div className="documents-grid">

    {

      documents.length === 0

      ?

      (

        <div className="empty-card">

          <FolderOpen size={40}/>

          <h3>

            No Documents Uploaded

          </h3>

        </div>

      )

      :

      documents.map(doc => (

        <div

          key={doc.id}

          className="document-card"

        >

          <FileText

            size={22}

          />

          <h4>

            {doc.document_type}

          </h4>

          <p>

            {doc.file_name}

          </p>

<div className="document-actions">

<button

className="view-btn"

onClick={()=>
viewDocument(doc)
}

>

<Eye size={16}/> View


</button>

<button

className="delete-btn"

onClick={()=>
deleteDocument(doc)
}

>

<Trash2 size={16}/> Delete

</button>

</div>

        </div>

      ))

    }

  </div>

</div>
</div>
</div>
  );

};

export default SimCardDetails;